export function securedEventPath({
  browsePhotosPath,
  organizerUserName,
  embedMode,
  cartId,
  secureAccessToken
}: {
  browsePhotosPath: string;
  organizerUserName: string;
  embedMode?: boolean;
  cartId?: string | number;
  secureAccessToken?: string;
}): string {
  let path = `${browsePhotosPath}?org=${organizerUserName}`;
  if (embedMode && cartId) {
    path += `&embed=true&cart_id=${cartId}`;
  }
  if (secureAccessToken) {
    path += `&p=${secureAccessToken}`;
  }
  return path;
}
